export default class CardSideAdapter {
    constructor(faceIsMain) {
        this.faceIsMain = !!faceIsMain;
    }

    static faceIsQuestion() {
        return new CardSideAdapter(true);
    }

    static backIsQuestion() {
        return new CardSideAdapter(false);
    }

    invert() {
        return new CardSideAdapter(!this.faceIsMain);
    }

    question(card) {
        return this.createQuestion(card);
    }

    createQuestion(card) {
        const o = {};
        this.fillQuestion(card, o);
        return o;
    }

    fillQuestion(card, question) {
        Object.assign(question, CardSideAdapter.createSide(card, this.faceIsMain))
    }

    answer(card) {
        return this.createAnswer(card);
    }

    createAnswer(card) {
        const o = {};
        this.fillAnswer(card, o);
        return o;
    }

    fillAnswer(card, answer) {
        Object.assign(answer, CardSideAdapter.createSide(card, !this.faceIsMain))
    }

    static createSide(card, faceIsMain) {
        const o = {
            id: card.id,
            textType: (faceIsMain ? card.faceT : card.backT) === 1 ? 'html' : 'text',
            text: faceIsMain ? card.faceText : card.backText,
            image: faceIsMain ? card.faceImageSrc : card.backImageSrc,
            audio: faceIsMain ? card.faceA : card.backA,
            lang: faceIsMain ? card.faceL : card.backL
        }

        if (o.textType === 'html') {
            o.textOnly = o.text
                .replace(/<\/p>/g, '\n')
                .replace(/<[^>]+>/g, '')
        } else {
            o.textOnly = o.text;
        }
        return o;
    }
}
